module.exports = __webpack_public_path__ + "images/cc4516b0a275ba078994bb7267815331b1c106150a8fce8e78d94520e1dbbe59.svg";